export const SOME_SCHEDULE_REQUEST = 'SOME_SCHEDULE_REQUEST'; // TODO: seems unused, remove it

export const SET_CURRENT_STYLIST = 'SET_CURRENT_STYLIST';
export const UPDATE_NEWBOOKING_DATE = 'UPDATE_NEWBOOKING_DATE';
export const SET_VIEW = 'SET_VIEW';
export const SAVE_DAYDATE = 'SAVE_DAYDATE';
export const STYLISTS_SAVE_ORDER_REQUEST = 'STYLISTS_SAVE_ORDER_REQUEST';
export const STYLISTS_SAVE_ORDER_SUCCESS = 'STYLISTS_SAVE_ORDER_SUCCESS';
export const STYLISTS_SAVE_ORDER_FAILURE = 'STYLISTS_SAVE_ORDER_FAILURE';
export const HIDE_INACTIVE_STYLISTS = 'HIDE_INACTIVE_STYLISTS';
export const HIDE_INACTIVE_STYLISTS_REQUEST = 'HIDE_INACTIVE_STYLISTS_REQUEST';
export const HIDE_INACTIVE_STYLISTS_FAILURE = 'HIDE_INACTIVE_STYLISTS_FAILURE';
export const SHOW_ALL_STYLISTS = 'SHOW_ALL_STYLISTS';

export const CHANGE_APPOINTMENT_STATUS_REQUEST = 'CHANGE_APPOINTMENT_STATUS_REQUEST';
export const CHANGE_APPOINTMENT_STATUS_SUCCESS = 'CHANGE_APPOINTMENT_STATUS_SUCCESS';
export const CHANGE_APPOINTMENT_STATUS_FAILURE = 'CHANGE_APPOINTMENT_STATUS_FAILURE';

export const FETCH_APPOINTMENT_DETAILS_REQUEST = 'FETCH_APPOINTMENT_DETAILS_REQUEST';
export const FETCH_APPOINTMENT_DETAILS_SUCCESS = 'FETCH_APPOINTMENT_DETAILS_SUCCESS';
export const FETCH_APPOINTMENT_DETAILS_FAILURE = 'FETCH_APPOINTMENT_DETAILS_FAILURE';

export const FETCH_CLIENT_LABELS_SUCCESS = 'FETCH_CLIENT_LABELS_SUCCESS';

export const SCHEDULER_FETCH_DEPOSIT_REQUEST = 'SCHEDULER_FETCH_DEPOSIT_REQUEST';
export const SCHEDULER_FETCH_DEPOSIT_SUCCESS = 'SCHEDULER_FETCH_DEPOSIT_SUCCESS';
export const SCHEDULER_FETCH_DEPOSIT_FAILURE = 'SCHEDULER_FETCH_DEPOSIT_FAILURE';

export const DAY_VIEW = 'Day';
export const WEEK_VIEW = 'Week';

export const SCHEDULER_UPDATED_APPOINTMENT = 'SCHEDULER_UPDATED_APPOINTMENT';
export const SCHEDULER_UPDATED_PROCEDURE = 'SCHEDULER_UPDATED_PROCEDURE';
export const SCHEDULER_UPDATED_EVENT = 'SCHEDULER_UPDATED_EVENT';

export const SCHEDULER_ALLOW_CREATION = 'SCHEDULER_ALLOW_CREATION';
export const SCHEDULER_ALLOW_MODAL = 'SCHEDULER_ALLOW_MODAL';

export const GET_DEPOSIT_CLIENTS_LIST_REQUEST = 'GET_DEPOSIT_CLIENTS_LIST_REQUEST';
export const GET_DEPOSIT_CLIENTS_LIST_SUCCESS = 'GET_DEPOSIT_CLIENTS_LIST_SUCCESS';
export const GET_DEPOSIT_CLIENTS_LIST_FAILURE = 'GET_DEPOSIT_CLIENTS_LIST_FAILURE';

export const SAVE_PREFERENCE_REQUEST = 'SAVE_PREFERENCE_REQUEST';
export const SAVE_PREFERENCE_SUCCESS = 'SAVE_PREFERENCE_SUCCESS';
export const DELETE_PREFERENCE_REQUEST = 'DELETE_PREFERENCE_REQUEST';
export const DELETE_PREFERENCE_SUCCESS = 'DELETE_PREFERENCE_SUCCESS';
export const DELETE_PREFERENCE_FAILURE = 'DELETE_PREFERENCE_FAILURE';

export const PUT_PROCEDURE_LOG_REQUEST = 'PUT_PROCEDURE_LOG_REQUEST';
export const PUT_PROCEDURE_LOG_SUCCESS = 'PUT_PROCEDURE_LOG_SUCCESS';
export const PUT_PROCEDURE_LOG_FAILURE = 'PUT_PROCEDURE_LOG_FAILURE';

export const SET_BOOKED_BY_BUTTON = 'SET_BOOKED_BY_BUTTON';

export const SET_DROP_TIME = 'SET_DROP_TIME';
export const EMPTY_APPOINTMENT_STATUS = 'EMPTY_APPOINTMENT_STATUS';
export const CLEAR_NOSHOW_CHARGE_INFO = 'CLEAR_NOSHOW_CHARGE_INFO';
export const REQUEST_DEPOSIT_REQUEST = 'REQUEST_DEPOSIT_REQUEST';
export const REQUEST_DEPOSIT_SUCCESS = 'REQUEST_DEPOSIT_SUCCESS';
export const REQUEST_DEPOSIT_FAILURE = 'REQUEST_DEPOSIT_FAILURE';
export const SET_DRAG_FROM = 'SET_DRAG_FROM';
export const CLEAR_REQUEST_DEPOSIT_SUCCESS = 'CLEAR_REQUEST_DEPOSIT_SUCCESS';
export const CLEAR_CHECKOUT_CLOSED = 'CLEAR_CHECKOUT_CLOSED';
